import script from "./section5.vue?vue&type=script&setup=true&lang=js"
export * from "./section5.vue?vue&type=script&setup=true&lang=js"

import "./section5.vue?vue&type=style&index=0&id=3199dd5c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3199dd5c"]])

export default __exports__